import type { Expense as StartupExpense, Revenue as StartupRevenue } from "../../types/startup.types";
import type { ExpenseData, ChartData as BurndownChartData } from "../../types/burndown.types";

// Map a burndown ExpenseData to a Startup Expense shape with sensible defaults
export function mapExpenseDataToStartup(exp: ExpenseData): StartupExpense {
  return {
    id: exp.id,
    name: exp.name,
    amount: exp.monthlyAmount ?? exp.oneTimeAmount ?? 0,
    monthlyAmount: exp.monthlyAmount,
    frequency: exp.isOneTime ? "one-time" : "monthly",
    category: exp.category,
    startDate: exp.startDate,
    endDate: exp.endDate,
    dayOfMonth: undefined,
    isRecurring: !exp.isOneTime,
    startupId: "",
    growthRate: exp.growthRate,
    expenseType: exp.expenseType ?? "fixed",
    revenueRatio: exp.revenueRatio,
    color: exp.color,
    isOneTime: exp.isOneTime,
    oneTimeAmount: exp.oneTimeAmount,
    createdAt: new Date(),
    updatedAt: new Date(),
  } as StartupExpense;
}

// Map a burndown RevenueData to a Startup Revenue shape with sensible defaults
export function mapRevenueDataToStartup(rev: any): StartupRevenue {
  return {
    id: rev.id,
    name: rev.name,
    amount: rev.monthlyAmount ?? rev.amount ?? 0,
    monthlyAmount: rev.monthlyAmount ?? rev.amount ?? 0,
    type: (rev.type ?? rev.category ?? "other") as any,
    date: rev.date ?? rev.startDate,
    dayOfMonth: undefined,
    description: rev.description ?? "",
    startupId: "",
    growthRate: rev.growthRate,
    isRecurring: rev.isRecurring,
    frequency: rev.frequency,
    startDate: rev.startDate,
    endDate: rev.endDate,
    category: rev.category,
    createdAt: new Date(),
    updatedAt: new Date(),
  } as StartupRevenue;
}

// Map an entire burndown ChartData to object with startup arrays
export function mapChartDataToStartup(chart: BurndownChartData) {
  return {
    ...chart,
    expenses: (chart.expenses || []).map(mapExpenseDataToStartup),
    revenues: (chart.revenues || []).map(mapRevenueDataToStartup),
    // Preserve customer projection data if it exists
    customerProjectionData: chart.customerProjectionData,
  };
}
